import { toReset, toSuccess } from 'react-async-client';
import { append, contains, without } from 'ramda';

import {
    SET_APPROVAL_PROJECT_LIST_SELECTED,
    SET_APPROVAL_PERSON_LIST_SELECTED,
    SET_REQUEST_LIST_SELECTED,
    SET_WORKSHEET_LIST_SELECTED,
    SET_WORKSHEET_MASS_LIST_SELECTED,
    SET_WORKSHEET_MASS_LIST_SELECTED_STAGE,
    SET_NOTDONE_LIST_SELECTED,

    GET_REQUEST_LIST,
    GET_APPROVAL_PROJECT_LIST,
    GET_APPROVAL_PERSON_LIST,
    GET_WORKSHEET_LIST,
    GET_WORKSHEET_MASS_LIST,
    GET_NOTDONE_LIST,
} from 'constants/actionTypes';

export const createSelectedReducer = (SET_SELECTED, GET_DATA) =>
    (state = [], action) => {
        let select = action.payload;

        switch(action.type) {
            case SET_SELECTED:
                if (select === null) {
                    return [];
                }

                if (contains(select, state)) {
                    return without([select], state);
                } else {
                    return append(select, state);
                }
            case toReset(GET_DATA):
            case toSuccess(GET_DATA):
                return [];
            default:
                return state;
        }
    };

export const approvalPersonListSelectedReducer = createSelectedReducer(
    SET_APPROVAL_PERSON_LIST_SELECTED,
    GET_APPROVAL_PERSON_LIST
);

export const approvalProjectListSelectedReducer = createSelectedReducer(
    SET_APPROVAL_PROJECT_LIST_SELECTED,
    GET_APPROVAL_PROJECT_LIST
);

export const requestListSelectedReducer = createSelectedReducer(
    SET_REQUEST_LIST_SELECTED,
    GET_REQUEST_LIST
);

export const worksheetMassListSelectedReducer = createSelectedReducer(
    SET_WORKSHEET_MASS_LIST_SELECTED,
    GET_WORKSHEET_MASS_LIST
);

export const worksheetMassListSelectedStageKeyReducer = (state = null, action) => {
    let stageKey = action.payload;

    switch(action.type) {
        case SET_WORKSHEET_MASS_LIST_SELECTED_STAGE:
            return stageKey;
        case toReset(GET_WORKSHEET_MASS_LIST):
        case toSuccess(GET_WORKSHEET_MASS_LIST):
            return null;
        default:
            return state;
    }
}

export const createRadioSelectedReducer = (SET_SELECTED, GET_DATA) => (state = null, action) => {
    switch(action.type) {
        case SET_SELECTED:
            return action.payload;
        case toReset(GET_DATA):
        case toSuccess(GET_DATA):
            return null;
        default:
            return state;
    }
};

export const worksheetListSelectedReducer = createRadioSelectedReducer(SET_WORKSHEET_LIST_SELECTED, GET_WORKSHEET_LIST);
export const notdoneListSelectedReducer = createRadioSelectedReducer(SET_NOTDONE_LIST_SELECTED, GET_NOTDONE_LIST);
